import { getAppKey, MODULE_ID } from "@/constants";
import { waitUntilGetGid } from "./gid";
import { getLocalIdentity } from "@meitu/xdesign-identity";
import { getJumpQuery } from '@meitu/xdesign-widgets/dist/overseasAccessModal/jumpQuery';
import { getEnterpriseID } from "@meitu/xdesign-widgets/dist/teamExports";
import { getQuery } from "./query";
import { StatData } from "@meitu/saas-mtstat/dist/type";
import store from "@/store";
import { checkIsInSdk, getAppId } from "./sdk";
import { SDK_PLATFORM, SdkModuleName } from "@/constants/workbench";
import cookie from "js-cookie";

export const getParameterValue = (inputString: string, key: string) => {
  // 构造正则表达式，匹配 "key=值" 的模式
  const regex = new RegExp(`${key}=([^&]*)`);

  // 使用正则表达式查找匹配项
  const match = inputString.match(regex);

  // 如果匹配成功，返回匹配的值，否则返回 null
  return match ? decodeURIComponent(match[1]) : "";
};

export const initMtstat = async (callback?: () => void) => {
  const sdkAppId = checkIsInSdk()
    ? getAppId
    : () => Promise.resolve({ app_id: "" });

  Promise.all([waitUntilGetGid(), sdkAppId()]).then(
    async ([wgid, { app_id }]) => {
      console.log("【appId】：", app_id);
      // 团队id
      const oid = String(getLocalIdentity()?.oid || "");
      const query = getQuery();
      const tool_url = decodeURIComponent(
        decodeURIComponent(query.tool_url || "")
      );
      const is = await import("@meitu/is");

      if (app_id) {
        if (SDK_PLATFORM[app_id]) {
          if (typeof window !== "undefined") {
            (window as any)._appId = app_id;
          }
        }
      }

      const mtxxWebGid = cookie.get(`mtxx_web_gid${process.env.NEXT_PUBLIC_ENV === "pre" ? '-pre' : process.env.NEXT_PUBLIC_ENV === 'beta' ? "-beta" : ""}`);
      const jumpQuery = getJumpQuery();

      // 埋点信息配置
      const statConfig: StatData = {
        appKey: getAppKey(), // 业务方申请的统计app_key，需要用字符串
        env: process.env.NEXT_PUBLIC_ENV === "release" ? "release" : "beta",
        moduleId: MODULE_ID,
        app_id: app_id,
        is_sdk:
          query.origin === SdkModuleName.aippt && checkIsInSdk()
            ? query.origin
            : "",
        company_key: SDK_PLATFORM[app_id] || query.platform || "",
        channel:
          query.hb_position || query.hb_operation
            ? "app"
            : (query.channel && decodeURIComponent(query.channel)) ||
            window.sessionStorage.getItem("channel") ||
            "",
        hb_position:
          getQuery().hb_position ||
          getParameterValue(tool_url, "hb_position") ||
          "",
        hb_operation:
          getQuery().hb_operation ||
          getParameterValue(tool_url, "hb_operation") ||
          "",
        indtool_source: query.indtool_source || "",
        operate_source: await getOperateSource(),
        from_app:
          is.isMobile && is.isXiuXiu
            ? "mtxx_app"
            : is.isMobile && is.isPoster
              ? "mtsjs_app"
              : "browser",
        funcEnter: "",
        abTestKey: "",
        sdkModuleName: "", //对外提供SDK时的 moduleName,没有SDK服务时填空
        customizedStatsMarker: false,
        oid,
        user_mode: getEnterpriseID() ? "1" : "",
        enterprise_id: getEnterpriseID() || "",
        mtxx_web_gid: mtxxWebGid || "",
        initAbTest: () => {
          callback?.();
        },
        successCallback: () => {
          store.getActions().setFinishTrack(true);
        },
        ...jumpQuery,
      };

      if (is.isMobile && (is.isXiuXiu || is.isPoster)) {
        try {
          const hogger = await import("@meitu/hogger");
          const [appInfo] = await hogger.getAppInfo();
          statConfig.gid = appInfo.gid;
        } catch (e) {
          console.log("【获取gid失败】：", e);
        }
      }

      // 实例化埋点
      import("@meitu/saas-mtstat").then((res) => {
        new res.SaasMTStat(statConfig);
      });
    }
  );
};

export const getOperateSource = async () => {
  const is = await import("@meitu/is");

  if (is.isMobile) return "h5";

  const clientInfo = await import("@meitu/pc-bridge").then(
    (res) => res.clientInfo
  );
  let operate_source = "web";
  if (clientInfo.isClient) {
    operate_source = clientInfo.isMac ? "macos" : "windows";
  }
  return operate_source;
};

/**
 * 埋点上报函数
 * @param eventName 事件名
 * @param args 参数
 */
export function statTrack(eventName: string, args: object) {
  if (!window._stat_track) {
    if (!window.__stat_stack) {
      window.__stat_stack = [];
    }
    window.__stat_stack.push({ name: eventName, options: args });
  } else {
    window._stat_track?.(eventName, args);
  }
}

/**
 * 设置用户公共参数
 * @param userInfo
 */
export const setUserCommonParams = ({
  isVip,
  availableAmount,
}: {
  isVip: boolean | undefined;
  availableAmount: number | undefined;
}) => {
  // 1）user_type（用户vip类型）：0非会员，1svip，2未登陆
  // 2) residual_meidou：剩余美豆数，未登陆上报no_login
  window.mtstat?.setCommonParams({
    user_type: isVip == null ? "2" : isVip ? "1" : "0",
    residual_meidou:
      availableAmount == null ? "no_login" : String(availableAmount),
  });
};
